<template>
  <div class="landing row sm-block">

    <div class="landing-content col-6 col-sm-12">

<div class="overlay"><div class="landingLogo"><img :src="`${publicPath}logo-color.svg`" alt="logo accueil"></div></div>
<div class="overlay"><h2 >Nicolas Noël </h2></div>
    <hr class="col-6">
<div class="overlay"><h3>Design Graphique, illustration et développement web</h3></div>
</div>
<div class="landingIllustration col-6 col-sm-12">
  <div class="overlay"><img id="portraitBack" :src="`${publicPath}portrait-back.png`" alt="logo accueil"></div>
  <div class="overlay"><img id="pattern" :src="`${publicPath}portrait-pattern.png`" alt="logo accueil"></div>
  <div class="overlay"><img id="portrait" :src="`${publicPath}portrait.png`" alt="logo accueil"></div>
</div>
</div>
</template>

<script>
export default {
  data : function () {
    return{
      publicPath: process.env.BASE_URL
    }
  }
}
</script>


<style scoped>

@-webkit-keyframes spin {
  0%   { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
}
@-moz-keyframes spin {
  0%   { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
}
@-o-keyframes spin {
  0%   { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
}
@keyframes spin {
  0%   { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
}

#pattern {
  -webkit-animation: spin 25s infinite linear; /* Safari 4+ */
  -moz-animation:    spin 25s infinite linear; /* Fx 5+ */
  -o-animation:      spin 25s infinite linear; /* Opera 12+ */
  animation:         spin 25s infinite linear; /* IE 10+, Fx 29+ */
}

.landing{
  min-height: 100vh;
  padding: 100px 6.25rem 0 6.25rem;
  display:flex;
  align-items: center;
  position: relative;
  overflow-x: hidden;
  overflow-y:hidden;
}

.landingIllustration{
  position: absolute;
left:45%;
  height: 100%;
  top:0;
  padding-top: 100px;

}


.landingIllustration img{
    padding-top: 50px;
max-height: 100%;
position: absolute;
left:0;
top:0;
}

.landing-content{
padding-left: 1.25rem;
z-index: 1000;
  padding-bottom: 100px;

}

.landingLogo img{
  max-height: 120px;
max-width: 210px;
}

h2{
  padding-top: 2.5rem;
  padding-bottom: 1.25rem;
  position: relative;
}

h3{
  color: #222
}

hr{
  margin-left: 0;
  border: solid 1px #dec8b2;
}

h3{
    padding-top: 1.25rem;
}

@media all and (max-width: 736px) {

  .sm-block{
    display: block;
  }

.landing{
  padding: 100px 4rem 0 4rem;
}

.landing-content{
  text-align: center;
  padding-bottom: 2rem;
}

hr{
  margin: auto;
}

.landingIllustration{
  position: relative;
  width: 100%;
  height: 80vh;

left:0;
padding-top: 0;
}

.landingIllustration img{

height: 100%;
position: absolute;

bottom: 0;
left: -9999px;
right: -9999px;
margin: auto;

}


}
</style>
